import React, { useEffect } from 'react';
import { Routes as RouterRoutes, Route, useLocation } from 'react-router-dom';
import SocialRail from '../Components/SocialRail';
import CookieConsent from '../Components/CookieConsent';
import { initAnalytics, trackPageView } from '../lib/analytics';
import { warmUpApi } from '../api';
import HomePage from './HomePage';
import AllProduct from './AllProduct';
import ProductPage from './Components/ProductPage';
import ProductDetail from './Components/ProductDetail';
import CustomizeCake from './CustomizeCake';
import AboutPage from './AboutPage';
import ContactUs from './ContactUs';
import Cart from './Cart';
import Checkout from './Checkout';
import PrivacyPolicy from './PrivacyPolicy';
import RefundPolicy from './RefundPolicy';
import TermsAndUse from './TermsAndUse';
import ShippingPolicy from './ShippingPolicy';
import MyOrders from './MyOrders';
import EventsPage from './EventsPage';
import CorporateEventsPage from './CorporateEventsPage';
import BlogPage from './BlogPage';
import BlogPost from './BlogPost';
import AdminLogin from './Admin/AdminLogin';
import AdminDashboard from './Admin/AdminDashboard';

function Routes() {
  const { pathname, search } = useLocation();

  // GA4: load the tag once, then report every route change as a page view.
  useEffect(() => { initAnalytics(); warmUpApi(); }, []);
  useEffect(() => {
    // Let the page set document.title before the view is reported.
    const id = window.setTimeout(() => trackPageView(pathname + search), 60);
    return () => window.clearTimeout(id);
  }, [pathname, search]);
  // Storefront only - the admin dashboard doesn't need a customer contact rail.
  const showSocialRail = !pathname.startsWith('/admin');

  return (
    <>
      <RouterRoutes>
        <Route path="/" element={<HomePage />} />
        <Route path="/allproduct" element={<AllProduct />} />
        <Route path="/category/:categoryName" element={<ProductPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/customize" element={<CustomizeCake />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/contact' element={<ContactUs/>} />
        <Route path='/cart' element={<Cart/>} />
        <Route path='/checkout' element={<Checkout/>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/terms" element={<TermsAndUse />} />
        <Route path="/shipping" element={<ShippingPolicy />} />
        <Route path='/myorders' element={<MyOrders/>}/>
        <Route path='/events' element={<EventsPage/>}/>
        <Route path='/corporate-events' element={<CorporateEventsPage/>}/>
        <Route path='/blog' element={<BlogPage/>}/>
        <Route path='/blog/:slug' element={<BlogPost/>}/>
        <Route path='/careers' element={<ContactUs/>}/>
        <Route path='/admin/login' element={<AdminLogin/>}/>
        <Route path='/admin' element={<AdminDashboard/>}/>
      </RouterRoutes>
      {showSocialRail && <SocialRail />}
      {showSocialRail && <CookieConsent />}
    </>
  );
}

export default Routes;
